module.exports = __webpack_public_path__ + "img/img (13).75bd20d4.jpg";